module.exports = new Promise((resolve, reject) => {
                var defaultUrl = 'https://envoy-public-eu-eu-central-1.s3.eu-central-1.amazonaws.com/react-rich-components/latest/remoteEntry.js';
                var params = new URLSearchParams(window.location.search);
                var revision = params.get('rrc-revision');
                // Support RRC revision loading in all environments:
                // - Production/Staging: defaultUrl contains /latest/, replace with /{revision}/ (same bucket)
                // - Local dev: defaultUrl is localhost, fall back to staging S3
                var s3Base = 'https://envoy-public-staging-us-east-2.s3.us-east-2.amazonaws.com/react-rich-components';
                var url;
                if (revision) {
                  url = defaultUrl.includes('/latest/')
                    ? defaultUrl.replace('/latest/', '/' + revision + '/')
                    : s3Base + '/' + revision + '/remoteEntry.js';
                } else {
                  url = defaultUrl;
                }
                function loadScript(src, onError) {
                  var s = document.createElement('script');
                  s.src = src;
                  s.onload = function() { resolve(window.reactRichComponents); };
                  s.onerror = onError;
                  document.head.appendChild(s);
                }
                loadScript(url, function() {
                  if (url !== defaultUrl) {
                    console.warn('[RRC Remote] revision "' + revision + '" not found, falling back to latest');
                    loadScript(defaultUrl, function() {
                      reject(new Error('Failed to load RRC remote: ' + defaultUrl));
                    });
                  } else {
                    reject(new Error('Failed to load RRC remote: ' + url));
                  }
                });
              });